





















import Vue from 'vue'

export default Vue.extend({
  name: 'talent-item',
  props: {
    talent: {
      type: Object,
      required: true,
    },
    rank: {
      type: Number,
      required: true,
    },
    hideLocked: {
      type: Boolean,
      required: false,
    },
    actionButtons: {
      type: Boolean,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    itemColor: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
  computed: {
    ranks() {
      if (this.hideLocked) return this.talent.Ranks.slice(0, this.rank)
      return this.talent.Ranks
    },
  },
})
